import { GridList, GridListTile, GridListTileBar, Checkbox, TablePagination } from "@material-ui/core";
import React, { Fragment } from "react";
import styles from "./ImageGrid.module.scss";
import { Loading } from "../loading/Loading";
import { getIcon, getIconPath } from "../../icon/icon";
import { PagePlaceholder } from "../page-placeholder/PagePlaceholder";

export default class ImageGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: props.currentSelection || [],
            loading: false,
            images: {},
            currentPage: 0,
            pageSize: 25,
            data: props.data
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.data !== this.props.data
            && nextState.images !== this.state.images
            && nextState.checked !== this.state.checked
            && nextState.currentPage !== this.state.currentPage
            && nextState.pageSize !== this.state.pageSize
        ) {
            return false
        }
        return true
    }

    handleToggle = id => () => {
        const currentIndex = this.state.checked.indexOf(id);
        const newChecked = [...this.state.checked];

        if (currentIndex === -1) {
            newChecked.push(id);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({ checked: newChecked });
        this.props.handleSelection(newChecked);
    }

    componentDidUpdate() {
        if (JSON.stringify(this.state.data) !== JSON.stringify(this.props.data)) {
            const { pageSize, currentPage } = this.state
            this.retrieveImages(currentPage, pageSize)
            this.setState({ data: this.props.data })
        }
    }

    componentDidMount() {
        const { pageSize, currentPage } = this.state
        this.retrieveImages(currentPage, pageSize)
    }

    changePage(currentPage, pageSize) {
        this.retrieveImages(currentPage, pageSize)
    }

    retrieveImages(currentPage, pageSize) {
        this.props.data.slice(currentPage * pageSize, currentPage * pageSize + pageSize).forEach(file => {
            this.props.retrieveImage(file.id, (id, value) => {
                this.setState({ images: { ...this.state.images, [id]: value } })
            });
        })
    }

    render() {
        console.log(this.props.data)

        const { pageSize, currentPage } = this.state
        return (
            <Fragment>
                <div className={styles.root}>
                    {this.props.data.length === 0 ?
                        <PagePlaceholder text={this.props.emptyPlaceholder} /> :
                        <GridList cellHeight={this.props.cellHeight} spacing={this.props.spacing} cols={this.props.cols} classes={{ root: styles.gridList }}>
                            {this.props.data.slice(currentPage * pageSize, currentPage * pageSize + pageSize).map(tile => (
                                <GridListTile key={tile.id} classes={{ tile: styles.imageTile }} onClick={this.handleToggle(tile.id)}>

                                    {this.state.images[tile.id] ?
                                        <img className={styles.image} src={this.state.images[tile.id]} alt={tile.Name} onError={e => {
                                            const image = getIcon("empty-file.svg");
                                            e.target.src = image.props.src
                                        }} /> :
                                        <Loading />
                                    }

                                    <GridListTileBar
                                        classes={{ actionIcon: styles.actionIcon }}
                                        actionPosition="left"
                                        title={tile.id}
                                        subtitle={tile.subtitle}
                                        actionIcon={
                                            this.props.selectable ?
                                                <Checkbox
                                                    edge="start"
                                                    checked={this.state.checked.indexOf(tile.id) !== -1}
                                                    tabIndex={-1}
                                                    disableRipple
                                                    inputProps={{ "aria-labelledby": tile.id }}
                                                /> :
                                                null
                                        }
                                    />
                                </GridListTile>
                            ))}
                        </GridList>
                    }
                </div>
                <TablePagination
                    className={styles.pagination}
                    component="nav"
                    page={this.state.currentPage}
                    rowsPerPage={this.state.pageSize}
                    count={this.props.data.length}
                    onChangePage={(evt, page) => {
                        this.setState({ currentPage: page })
                        this.changePage(page, this.state.pageSize)
                    }}
                    onChangeRowsPerPage={(event) => {
                        const pageSize = event.target.value
                        this.setState({ pageSize: pageSize, currentPage: 0 })
                        this.changePage(0, pageSize)
                    }}
                />
            </Fragment>
        );
    }
}